import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PullOutMoreCard from './pull-out-more-card/pull-out-more-card';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { LEARNING_MAP_CONTENT_TYPE, DEPTH_FILTER } from '@/utils/constants';

@Component({
    name: 'tree-pull-out',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
        'pull-out-more': PullOutMoreCard,
    },
})

export default class PullOutTree extends Vue {

    // ------------------------------------------------------------------
    // Properties

    @Prop()
    private content: any;

    @Prop()
    private selectedItems: any;

    private learnerContent = LEARNING_MAP_CONTENT_TYPE;

    private getPulloutInfo: any = {};

    private pullOutContents: any = [];

    private isShowMore: boolean = false;

    private get disableShowMore() {
        return this.selectedFilter.depth >= 5;
    }

    private get selectedFilter() {
        return this.selectedItems;
    }

    private get signatureCollections() {
        return this.content.signatureCollections || [];
    }

    private get signatureAssessments() {
        return this.content.signatureAssessments || [];
    }

    private get countList() {
        return this.content.totalHitCount || this.content.totalCounts;
    }

    private get breadCrumb() {
        const path: any = [];
        const list = (item: any, callback: any) => {

            if (item.depth > 1 && item.depth < 5) {
                path.push(item.name);
                callback(item.parent, list);
            }
        };
        list(this.selectedFilter, list);
        return path.reverse().join(' > ');
    }

    // ------------------------------------------------------------------------
    // Actions
    private closeContainer() {
        if (this.$parent) {
            this.$parent.$data.isShowPullout = false;
        }
    }
    private onShowMore() {
        this.pullOutContents = this.content.contents || [];
        this.isShowMore = !this.isShowMore;
        (this.$el as HTMLElement).style.width = this.isShowMore ? '100%' : '450px';
    }

}
